import { UserRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useApp } from "@/context/AppContext";
import { mediaSrc } from "@/lib/api";

export default function FacultyDialog({ trigger }) {
  const { settings, t, pick, lang } = useApp();
  const d = settings.doctor;
  const photo = mediaSrc(settings.media.photo);
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className={`glass max-w-2xl rounded-3xl border-emerald-300/20 text-emerald-50 ${lang === "ml" ? "lang-ml" : ""}`} data-testid="faculty-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-white">{t("knowDoctor")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
          {photo ? (
            <img src={photo} alt={d.name_en} data-testid="doctor-photo" className="h-28 w-28 rounded-2xl object-cover ring-1 ring-emerald-300/30" />
          ) : (
            <div data-testid="doctor-photo" className="flex h-28 w-28 items-center justify-center rounded-2xl bg-emerald-500/10 ring-1 ring-emerald-300/30">
              <UserRound className="h-12 w-12 text-emerald-300/70" />
            </div>
          )}
          <div>
            <p className="font-display text-xl font-semibold text-white" data-testid="doctor-name">{pick(d, "name")}</p>
            <p className="text-sm text-amber-200">{pick(d, "title")}</p>
          </div>
        </div>
        <ScrollArea className="max-h-[50vh] pr-3">
          <p className="whitespace-pre-line text-sm leading-relaxed text-emerald-50/85" data-testid="doctor-bio">{pick(d, "bio")}</p>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
